import { render, staticRenderFns } from "./taskRelease.vue?vue&type=template&id=45af2f23&scoped=true&"
import script from "./taskRelease.vue?vue&type=script&lang=js&"
export * from "./taskRelease.vue?vue&type=script&lang=js&"
import style0 from "./taskRelease.vue?vue&type=style&index=0&id=45af2f23&scoped=true&lang=css&"
import style1 from "./taskRelease.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45af2f23",
  null
  
)

export default component.exports